(function(){
  'use strict';
  if(window.CPProductExperience)return;
  function init(root){
    if(!root || root.dataset.cpProductReady)return;
    root.dataset.cpProductReady='1';
    root.querySelectorAll('a[href="#cp-reorder-planning"]').forEach(function(link){link.addEventListener('click',function(){var planner=root.querySelector('#cp-reorder-planning');if(planner)planner.open=true;});});
    // Gallery-only enhancement. The purchase and variant workflow below is unchanged.
    var stage=root.querySelector('[data-cp-stage]');
    var slides=Array.prototype.slice.call(root.querySelectorAll('[data-cp-product-slide]'));
    var thumbs=Array.prototype.slice.call(root.querySelectorAll('[data-cp-thumb]'));
    var prev=root.querySelector('[data-cp-product-prev]');
    var next=root.querySelector('[data-cp-product-next]');
    var count=root.querySelector('[data-cp-product-count]');
    var gallery=root.querySelector('[data-cp-gallery]');
    var caption=root.querySelector('[data-cp-gallery-caption]');
    var thumbRail=root.querySelector('[data-cp-gallery-thumbs]');
    var zoomButton=root.querySelector('[data-cp-gallery-zoom]');
    var dialog=root.querySelector('[data-cp-gallery-dialog]');
    var fullImage=dialog && dialog.querySelector('[data-cp-gallery-full]');
    var fullCaption=dialog && dialog.querySelector('[data-cp-gallery-full-caption]');
    var fullStatus=dialog && dialog.querySelector('[data-cp-gallery-full-status]');
    var dialogCount=dialog && dialog.querySelector('[data-cp-gallery-dialog-count]');
    var dialogClose=dialog && dialog.querySelector('[data-cp-gallery-close]');
    var zoomPrev=dialog && dialog.querySelector('[data-cp-gallery-zoom-prev]');
    var zoomNext=dialog && dialog.querySelector('[data-cp-gallery-zoom-next]');
    var current=Math.max(0,slides.findIndex(function(slide){return slide.classList.contains('is-active');}));
    var startX=null,startY=null,pointerId=null,swipeUntil=0;
    var returnFocus=null,savedOverflow='',ownsScrollLock=false;
    function isImage(slide){return !!(slide && slide.dataset.fullSrc && (!slide.dataset.mediaType || slide.dataset.mediaType==='image'));}
    function imageIndices(){return slides.map(function(slide,i){return isImage(slide)?i:-1;}).filter(function(i){return i>=0;});}
    function pauseSlide(slide){
      slide.querySelectorAll('video').forEach(function(video){try{video.pause();}catch(_) {}});
      // Removing the embedded player stops remote video without sending cross-origin messages.
      slide.querySelectorAll('[data-cp-gallery-player]').forEach(function(player){player.remove();});
      var play=slide.querySelector('[data-cp-gallery-load]');
      if(play)play.hidden=false;
    }
    function keepThumbVisible(){
      var thumb=thumbs[current];
      if(!thumbRail || !thumb || thumbRail.scrollWidth<=thumbRail.clientWidth)return;
      var box=thumb.getBoundingClientRect(),railBox=thumbRail.getBoundingClientRect();
      var delta=box.left<railBox.left?box.left-railBox.left:box.right>railBox.right?box.right-railBox.right:0;
      if(delta)thumbRail.scrollLeft+=delta; // Horizontal only: never scroll the page to the gallery.
    }
    function renderZoom(){
      var slide=slides[current];
      if(!dialog || !fullImage || !isImage(slide))return;
      var indices=imageIndices();
      if(dialogCount)dialogCount.textContent='Image '+(indices.indexOf(current)+1)+' of '+indices.length;
      var image=slide.querySelector('img');
      fullImage.alt=image && image.alt || root.dataset.productTitle || 'Product image';
      if(fullCaption)fullCaption.textContent=slide.dataset.caption || fullImage.alt;
      if(fullImage.getAttribute('src')!==slide.dataset.fullSrc){
        fullImage.hidden=false;
        if(fullStatus)fullStatus.hidden=true;
        fullImage.src=slide.dataset.fullSrc;
      }
      if(zoomPrev)zoomPrev.hidden=indices.length<2;
      if(zoomNext)zoomNext.hidden=indices.length<2;
    }
    function showImage(index){
      if(!slides.length)return;
      index=Number(index);
      if(!Number.isFinite(index))return;
      current=((Math.trunc(index)%slides.length)+slides.length)%slides.length;
      slides.forEach(function(slide,i){
        var active=i===current;
        if(!active){
          if(slide.contains(document.activeElement) && stage)stage.focus({preventScroll:true});
          pauseSlide(slide);
        }
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',active?'false':'true');
        if(active)slide.removeAttribute('inert');else slide.setAttribute('inert','');
        var image=slide.querySelector('img');
        if(image){image.draggable=false;if(active)image.loading='eager';}
      });
      thumbs.forEach(function(button,i){
        var active=i===current;
        button.classList.toggle('is-active',active);
        if(active)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');
      });
      if(count)count.textContent=(current+1)+' / '+slides.length;
      if(caption)caption.textContent=slides[current].dataset.caption || '';
      if(zoomButton)zoomButton.hidden=!(isImage(slides[current]) && dialog && typeof dialog.showModal==='function');
      if(gallery)gallery.dataset.activeMedia=slides[current].dataset.mediaId || '';
      keepThumbVisible();
      if(dialog && dialog.open){if(isImage(slides[current]))renderZoom();else dialog.close();}
    }
    function resetSwipe(){startX=startY=null;pointerId=null;}
    function swipeEnd(x,y){
      if(startX===null)return;
      var dx=x-startX,dy=y-startY;
      resetSwipe();
      if(Math.abs(dx)>34 && Math.abs(dx)>Math.abs(dy)*1.2){
        swipeUntil=Date.now()+400;
        showImage(current+(dx<0?1:-1));
      }
    }
    function interactiveTarget(target){return !!(target && target.closest && target.closest('button,a,input,select,textarea,video,audio,iframe,model-viewer,[contenteditable]'));}
    thumbs.forEach(function(button){button.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();showImage(Number(button.dataset.index||0));});});
    if(prev)prev.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();showImage(current-1);});
    if(next)next.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();showImage(current+1);});
    if(stage && slides.length>1){
      stage.addEventListener('keydown',function(event){
        if(event.target!==stage || event.altKey || event.ctrlKey || event.metaKey)return;
        if(event.key==='ArrowLeft'){event.preventDefault();showImage(current-1);}
        if(event.key==='ArrowRight'){event.preventDefault();showImage(current+1);}
        if(event.key==='Home'){event.preventDefault();showImage(0);}
        if(event.key==='End'){event.preventDefault();showImage(slides.length-1);}
      });
      stage.addEventListener('pointerdown',function(event){
        if(event.isPrimary===false){resetSwipe();return;}
        if(event.pointerType==='mouse' || event.button!==0 || interactiveTarget(event.target))return;
        pointerId=event.pointerId;startX=event.clientX;startY=event.clientY;
      },{passive:true});
      stage.addEventListener('pointerup',function(event){if(pointerId===event.pointerId)swipeEnd(event.clientX,event.clientY);},{passive:true});
      stage.addEventListener('pointercancel',resetSwipe);
      if(!window.PointerEvent){
        stage.addEventListener('touchstart',function(event){
          if(event.touches && event.touches.length===1 && !interactiveTarget(event.target)){startX=event.touches[0].clientX;startY=event.touches[0].clientY;}
          else resetSwipe();
        },{passive:true});
        stage.addEventListener('touchend',function(event){if(event.changedTouches && event.changedTouches.length)swipeEnd(event.changedTouches[0].clientX,event.changedTouches[0].clientY);},{passive:true});
        stage.addEventListener('touchcancel',resetSwipe);
      }
    }
    function restoreDialogFocus(){
      if(ownsScrollLock){document.body.style.overflow=savedOverflow;ownsScrollLock=false;}
      if(returnFocus && returnFocus.isConnected)returnFocus.focus({preventScroll:true});
      returnFocus=null;
    }
    function openZoom(){
      if(Date.now()<swipeUntil || !dialog || typeof dialog.showModal!=='function' || !isImage(slides[current]))return;
      returnFocus=document.activeElement;
      renderZoom();
      try{dialog.showModal();}catch(_){returnFocus=null;return;}
      savedOverflow=document.body.style.overflow;
      document.body.style.overflow='hidden';ownsScrollLock=true;
      if(dialogClose)dialogClose.focus({preventScroll:true});
    }
    function stepZoom(direction){
      var indices=imageIndices();if(indices.length<2)return;
      var index=indices.indexOf(current);
      showImage(indices[(index+direction+indices.length)%indices.length]);
    }
    if(zoomButton)zoomButton.addEventListener('click',openZoom);
    if(dialog){
      if(dialogClose)dialogClose.addEventListener('click',function(){dialog.close();});
      dialog.addEventListener('close',restoreDialogFocus);
      dialog.addEventListener('click',function(event){if(event.target===dialog){var rect=dialog.getBoundingClientRect();if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom)dialog.close();}});
      dialog.addEventListener('keydown',function(event){
        if(event.key==='ArrowLeft'){event.preventDefault();stepZoom(-1);}
        if(event.key==='ArrowRight'){event.preventDefault();stepZoom(1);}
      });
      if(zoomPrev)zoomPrev.addEventListener('click',function(){stepZoom(-1);});
      if(zoomNext)zoomNext.addEventListener('click',function(){stepZoom(1);});
      if(fullImage){
        fullImage.addEventListener('error',function(){fullImage.hidden=true;if(fullStatus){fullStatus.textContent='This larger image could not load. Close the viewer or try another image.';fullStatus.hidden=false;}});
        fullImage.addEventListener('load',function(){fullImage.hidden=false;if(fullStatus)fullStatus.hidden=true;});
      }
    }
    root.querySelectorAll('[data-cp-gallery-load]').forEach(function(button){button.addEventListener('click',function(){
      var slide=button.closest('[data-cp-product-slide]'),template=slide && slide.querySelector('[data-cp-gallery-embed]');
      if(!template || slide.querySelector('[data-cp-gallery-player]'))return;
      var player=document.createElement('div');player.className='cp-gallery__player';player.dataset.cpGalleryPlayer='';
      player.appendChild(template.content.cloneNode(true));slide.appendChild(player);button.hidden=true;
      var model=player.querySelector('model-viewer');
      if(model && window.Shopify && typeof window.Shopify.loadFeatures==='function'){
        window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:function(error){
          if(error || !model.isConnected || !window.Shopify.ModelViewerUI)return;
          try{new window.Shopify.ModelViewerUI(model);}catch(_){}
        }}]);
      }
      var focusable=player.querySelector('iframe,model-viewer,video');if(focusable)focusable.focus({preventScroll:true});
    });});
    function unloadGallery(event){
      if(event.target===root || event.target.contains(root)){
        returnFocus=null;
        if(dialog && dialog.open)dialog.close();
        restoreDialogFocus();slides.forEach(pauseSlide);
        document.removeEventListener('shopify:section:unload',unloadGallery);
      }
    }
    if(gallery)document.addEventListener('shopify:section:unload',unloadGallery);
    showImage(current);
    // Carry a planner's configuration into the quote shortlist, not into a purchasable variant.
    if (root.dataset.purchaseMode === 'quote') {
      try {
        var configuration = (new URL(location.href).searchParams.get('configuration') || '').replace(/[\x00-\x1f]/g, '').trim().slice(0, 160);
        if (configuration) {
          var configurationNote = document.createElement('p'); configurationNote.className = 'cp-product__human-help';
          configurationNote.textContent = 'Configuration to discuss: ' + configuration + '. Please confirm this arrangement in your quotation; options below are not selected automatically.';
          var target = root.querySelector('[data-cp-stock]'); if (target) target.after(configurationNote);
          root.querySelectorAll('[data-cp-project-add]').forEach(function (button) { button.dataset.title = (root.dataset.productTitle || button.dataset.title || 'Equipment') + ' — ' + configuration; });
        }
      } catch (_) {}
    }

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-cp-variant-data]').textContent); } catch (_) {}
    var form = root.querySelector('form.cp-product__form');
    var variantInput = form && form.querySelector('[name="id"]');
    var plan = form && form.querySelector('[name="selling_plan"]');
    var quantity = form && form.querySelector('[name="quantity"]');
    var addButton = root.querySelector('[data-cp-add-button]');
    var price = root.querySelector('[data-cp-price]');
    var stock = root.querySelector('[data-cp-stock]');
    var status = form && form.querySelector('[data-cp-cart-status]');
    var busy = false;
    var activeVariant = null;
    var activePlan = null;
    var initial = true;
    function selectedVariant() {
      var id = variantInput && variantInput.value || root.dataset.selectedVariant;
      return variants.find(function (variant) { return String(variant.id) === String(id); }) || (!id ? variants[0] : null);
    }
    function statusMessage(message, cartLink) {
      if (!status) return;
      status.hidden = false; status.textContent = message;
      if (cartLink) {
        var a = document.createElement('a'); a.href = window.routes && window.routes.cart_url || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
        a.textContent = ' View basket'; status.appendChild(a);
      }
    }
    function updatePlans(variant) {
      if (!plan) return;
      var previous = plan.value;
      var plans = Array.isArray(variant.plans) ? variant.plans : [];
      if (initial) { try { previous = new URL(location.href).searchParams.get('selling_plan') || previous; } catch (_) {} }
      plan.replaceChildren();
      if (!variant.requiresSellingPlan) plan.add(new Option('One-time purchase', ''));
      plans.forEach(function (allocation) { plan.add(new Option(allocation.name + ' — ' + (root.dataset.priceOnRequest === 'true' || !(Number(allocation.price) > 0) ? 'Price on request' : allocation.priceFormatted), String(allocation.id))); });
      if (plans.some(function (allocation) { return String(allocation.id) === previous; })) plan.value = previous;
      else if (variant.requiresSellingPlan && plans.length) plan.value = String(plans[0].id);
      else plan.value = '';
      plan.required = !!variant.requiresSellingPlan;
      plan.disabled = !plans.length && !variant.requiresSellingPlan;
      var field = root.querySelector('[data-cp-plan-field]'); if (field) field.hidden = !plans.length && !variant.requiresSellingPlan;
    }
    function purchaseState(variant, amount) {
      if (!window.CPPurchaseState) return 'unavailable';
      return window.CPPurchaseState.evaluate(variant, {
        amount: amount, plan: activePlan, quantity: quantity && quantity.value,
        equipment: root.dataset.productCategory === 'equipment', mode: root.dataset.purchaseMode,
        priceOnRequest: root.dataset.priceOnRequest === 'true'
      });
    }
    function sync(changeVariant, updateUrl) {
      var variant = selectedVariant();
      if (!variant) { if (addButton) addButton.disabled = true; return; }
      activeVariant = variant;
      var sku = root.querySelector('[data-cp-sku]'), skuRow = root.querySelector('[data-cp-sku-row]');
      if (sku) sku.textContent = variant.sku || '';
      if (skuRow) skuRow.hidden = !variant.sku;
      if (changeVariant) updatePlans(variant);
      activePlan = (variant.plans || []).find(function (allocation) { return plan && String(allocation.id) === plan.value; }) || null;
      var amount = activePlan ? activePlan.price : variant.price;
      var formatted = activePlan ? activePlan.priceFormatted : variant.priceFormatted;
      if (quantity && changeVariant) {
        quantity.min = variant.quantityMin || 1; quantity.step = variant.quantityIncrement || 1;
        if (variant.quantityMax != null) quantity.max = variant.quantityMax; else quantity.removeAttribute('max');
        var normal = window.CPProductTools && window.CPProductTools.normaliseQuantity(quantity.value, quantity);
        if (normal != null) quantity.value = normal;
      }
      if (!activePlan && quantity) (variant.quantityPriceBreaks || []).forEach(function (item) {
        if (Number(quantity.value) >= item.minimum) { amount = item.price; formatted = item.priceFormatted; }
      });
      var result = purchaseState(variant, amount);
      var available = result === 'ready';
      var enquiryOnly = result === 'no-price' || result === 'quote-only';
      var buyRow = root.querySelector('[data-cp-buy-row]');
      if (buyRow) buyRow.hidden = enquiryOnly;
      if (addButton) { addButton.disabled = busy || !available; if (!busy) addButton.textContent = addButton.dataset.addLabel || 'Add to cart'; }
      var purchaseNote = root.querySelector('[data-cp-purchase-note]');
      if (purchaseNote) { purchaseNote.hidden = enquiryOnly; purchaseNote.textContent = window.CPPurchaseState ? window.CPPurchaseState.message(result) : 'Check this option with Café Perfection.'; }
      var quotePrice = root.dataset.priceOnRequest === 'true' || !(Number(amount) > 0);
      if (quotePrice) formatted = 'Price on request';
      if (price) { price.textContent = formatted; price.hidden = !quotePrice && !(Number(amount) > 0); }
      var compare = root.querySelector('[data-cp-compare-price]');
      if (compare) { compare.hidden = quotePrice || !!activePlan || !(variant.compareAtPrice > amount); var previous = compare.querySelector('s'); if (previous) previous.textContent = variant.compareAtPriceFormatted || ''; }
      var note = root.querySelector('[data-cp-plan-note]');
      if (note) note.textContent = activePlan ? activePlan.name + '. ' + (activePlan.description || 'Review delivery, billing and cancellation terms at checkout.') : 'One-time purchase. No repeat delivery has been selected.';
      if (stock) {
        stock.hidden = !variant.inventoryManaged;
        if (variant.inventoryManaged) {
          var label = 'Out of stock', klass = 'is-out';
          if (variant.inventoryQuantity > 0) { label = variant.inventoryQuantity <= 5 ? 'Low stock' : 'In stock'; klass = variant.inventoryQuantity <= 5 ? 'is-low' : 'is-in'; }
          else if (variant.inventoryPolicy === 'continue' && root.dataset.productCategory !== 'equipment') { label = 'Available to order'; klass = 'is-order'; }
          if (root.dataset.purchaseMode === 'quote' && root.dataset.availabilityMode === 'enquiry') { label = 'Available to discuss • quotation required'; klass = 'is-order'; }
          var span = document.createElement('span'); span.className = klass; span.textContent = label; stock.replaceChildren(span);
        }
      }
      root.querySelectorAll('[data-cp-consumer-product]').forEach(function (node) {
        node.dataset.variant = variant.id; node.dataset.price = formatted; node.dataset.available = String(available);
        if (!node.cpDefaultImage) node.cpDefaultImage = node.dataset.image || '';
        node.dataset.image = variant.image || node.cpDefaultImage;
      });
      root.querySelectorAll('[data-cp-outright-price]').forEach(function (node) { node.textContent = quotePrice ? 'Price on request' : variant.priceFormatted; });
      root.querySelectorAll('[data-cp-project-add]').forEach(function (node) { node.dataset.price = quotePrice ? 'Price on request' : variant.priceFormatted; });
      root.querySelectorAll('a[href*="/pages/contact-us"]').forEach(function (link) {
        try { var enquiry = new URL(link.href, location.href); enquiry.searchParams.set('product', root.dataset.productHandle); enquiry.searchParams.set('variant', variant.id); enquiry.searchParams.set('option', variant.title); link.href = enquiry.pathname + enquiry.search; } catch (_) {}
      });
      if (window.CPProductTools) window.CPProductTools.syncVariant(root, variant, amount);
      if (changeVariant && variant.mediaId) {
        var mediaIndex = slides.findIndex(function (slide) { return slide.dataset.mediaId === String(variant.mediaId); });
        if (mediaIndex >= 0) showImage(mediaIndex);
      }
      if (updateUrl && variantInput) {
        try { var url = new URL(location.href); url.searchParams.set('variant', variant.id); if (activePlan) url.searchParams.set('selling_plan', activePlan.id); else url.searchParams.delete('selling_plan'); history.replaceState(history.state, '', url.pathname + url.search + url.hash); } catch (_) {}
      }
      root.dispatchEvent(new CustomEvent('cp:variant:change', { bubbles: true, detail: { variant: variant, plan: activePlan, price: amount } }));
      initial = false;
    }
    if (variantInput) variantInput.addEventListener('change', function () {
      sync(true, true);
      if (window.CPAnalytics) window.CPAnalytics.track('cp_variant_change', { product: root.dataset.productHandle, variant_id: variantInput.value, available: !!(activeVariant && activeVariant.available) });
    });
    if (plan) plan.addEventListener('change', function () { sync(false, true); });
    if (quantity) quantity.addEventListener('change', function () { sync(false, false); });
    if (form) form.addEventListener('submit', async function (event) {
      if (busy) { event.preventDefault(); return; }
      if (!form.checkValidity() || purchaseState(activeVariant, activePlan ? activePlan.price : activeVariant && activeVariant.price) !== 'ready') {
        event.preventDefault(); form.reportValidity(); sync(false, false); return;
      }
      if (window.CPAnalytics) window.CPAnalytics.track('cp_add_to_cart_attempt', { product: root.dataset.productHandle, variant_id: activeVariant.id, quantity: Number(quantity && quantity.value || 1) });
      if (!window.CPCartBridge) return;
      event.preventDefault();
      var values = new FormData(form);
      var properties = {};
      values.forEach(function (value, key) { var match = key.match(/^properties\[(.+)\]$/); if (match && typeof value === 'string') properties[match[1]] = value; });
      // File upload line-item properties require the native multipart form.
      if (Array.from(values.values()).some(function (value) { return value instanceof File && value.size > 0; })) { form.submit(); return; }
      busy = true; form.setAttribute('aria-busy', 'true');
      if (addButton) { addButton.disabled = true; addButton.textContent = 'Adding…'; }
      try {
        await window.CPCartBridge.addItems([{ id: String(values.get('id')), quantity: Number(values.get('quantity') || 1), selling_plan: values.get('selling_plan') || '', properties: properties, product: { handle: root.dataset.productHandle } }], { source: 'cp-product-page', activeElement: addButton });
        statusMessage('Added to your basket.', true);
      } catch (error) {
        statusMessage(String(error && error.message || 'The basket could not be confirmed. Please check your basket before retrying.'), true);
      } finally { busy = false; form.removeAttribute('aria-busy'); sync(false, false); }
    });
    root.querySelectorAll('[data-cp-product-print]').forEach(function (button) { button.addEventListener('click', function () { if (window.CPAnalytics) window.CPAnalytics.track('cp_product_page_print', { product: root.dataset.productHandle }); window.print(); }); });
    root.querySelectorAll('[data-cp-event]').forEach(function (element) { element.addEventListener('click', function () { if (window.CPAnalytics) window.CPAnalytics.track('cp_' + element.dataset.cpEvent, { product: root.dataset.productHandle, product_id: root.dataset.productId || '', purchase_mode: root.dataset.purchaseMode || '', link_path: element.getAttribute('href') || '' }); }); });
    if (window.CPProductTools) window.CPProductTools.init(root);
    sync(true, false);
    // The Google & YouTube app owns the standard view_item event.
  }
  function scan(scope) { (scope || document).querySelectorAll('[data-cp-product]').forEach(init); }
  window.CPProductExperience = { init: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }); else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
